import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";
import apiClient from "../../services/Http";

const notiMessage = new NotiMessage("success");

//presumptive
const allUrl = "presumptive/get?";
const eachUrl = "presumptive/getEach?";
const createUrl = "presumptive/addNew";
const updateUrl = "presumptive/update";
const indexCodeUrl = "presumptive/index_code?";
const previousCodeUrl = "presumptive/previous_code?";

//presumptive times
const addTimesUrl = "presumptive/diagnosis/store";
const updateTimesUrl = "presumptive/diagnosis/edit";
const eachTimesUrl = "presumptive/diagnosis/getEach?";

//cis
// const addCiUrl = "presumptive/ci/store";
// const eachCiUrl = "presumptive/ci/getEach?";

const state = {
    presumptiveData: [],
    presumptiveDataEach: {},
    ciDataEach: {},
    time: {},
};
const getters = {
    timeHandler(state) {
        var symptons = [];
        for (var i in state.time.symptons) {
            symptons.push(state.time.symptons[i].id);
        }
        state.time.symptons = symptons;

        var risk_factors = [];
        for (var b in state.time.risk_factors) {
            risk_factors.push(state.time.risk_factors[b].id);
        }
        state.time.risk_factors = risk_factors;

        return state.time;
    },
};
const mutations = {
    SET_PRESUMPTIVE_DATA(state, payload) {
        state.presumptiveData = payload.data.data;
    },
    SET_PRESUMPTIVE_DATA_ByParams(state, payload) {
        state.presumptiveDataEach.name = payload.name;
        state.presumptiveDataEach.sex = payload.sex;
    },
    SET_TIME_EACH(state, payload) {
        state.time = payload.data.data;
    },
    SET_PRESUMPTIVE_DATA_EACH(state, payload) {
        state.presumptiveDataEach = payload.data.data;
    },
    SET_CI_DATA_EACH(state, payload) {
        state.ciDataEach = payload.data.data;
    },
    
    CLEAR_PRESUMPTIVE_DATA(state) {
        state.presumptiveData = [];
    },
};

const actions = {
    async getPresumptiveEach({ commit }, id) {
        const response = await Request.get_data(eachUrl, {
            column: "id",
            value: id,
        });
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_PRESUMPTIVE_DATA_EACH", response);
    },
    async getPresumptiveData({ commit }, payload) {
        const response = await Request.get_data(allUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_PRESUMPTIVE_DATA", response);
    },
    async getSupportingTownshipPresumptiveData({ commit }, payload) {
        const response = await Request.get_data('presumptive/getSupportingTownshipPresumptive?', payload);
        if (response.status == 200)
            commit("SET_PRESUMPTIVE_DATA", response);
    },
    setPresumptiveEachByParam({ commit }, payload) {
        commit("SET_PRESUMPTIVE_DATA_ByParams", payload);
    },
    clearPresumptiveEach({ commit }) {
        commit("SET_PRESUMPTIVE_DATA", null);
    },
    async searchByIndexCode({ commit }, payload) {
        const response = await Request.get_data(indexCodeUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_PRESUMPTIVE_DATA", response);
    },
    async searchByPreviousCode({ commit }, payload) {
        const response = await Request.get_data(previousCodeUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_PRESUMPTIVE_DATA", response);
    },
    clearData({ commit }) {
        commit("CLEAR_PRESUMPTIVE_DATA");
    },
    async createPresumptive(context, payload) {
        const response = await Request.post_data(createUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess()) {
            notiMessage.displayNotiMsg("Saved Success");
            return true;
        }
        return false;
    },
    async editInfo(context, payload) {
        const response = await Request.post_data(updateUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess()) {
            notiMessage.displayNotiMsg("Updated Success");
            return true;
        }
        return false;
    },
    async getTimeDataEach({ commit }, payload) {
        const response = await Request.get_data(eachTimesUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess())
            commit("SET_TIME_EACH", response);
    },
    async addTimes(context, payload) {
        const response = await Request.post_data(addTimesUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess()) {
            notiMessage.displayNotiMsg("Saved Success");
            return true;
        }
        return false;
    },
    async updateTime(context, payload) {
        const response = await Request.post_data(updateTimesUrl, payload);
        const responseChecker = new ResponseChecker(response);
        responseChecker.checkResponse();
        if (responseChecker.isResponseStatusSuccess()) {
            notiMessage.displayNotiMsg("Saved Success");
            return true;
        }
        return false;
    },
    async deletePresumptive(context, payload) {
        const response = await Request.post_data(
            "presumptive/delete",
            payload
        );
        if (response.data.success) {
            const diagnosisResponse = await Request.post_data(
                "presumptive/diagnosis/delete",
                payload
            );
            if (diagnosisResponse.data.success) {
                notiMessage.displayNotiMsg("Deleted Success");
                return true;
            }
            return false;
        }
    },
    async deleteTime(context, payload) {
        const response = await Request.post_data(
            "presumptive/diagnosis/delete-each",
            payload
        );
        if (response.data.success) {

            notiMessage.displayNotiMsg("Deleted Success");
            return true;
        }
        return false;
    },
    async getExport(context, payload) {
        let url = `https://api.mdr.tbtheunion.com/api/presumptive/export?`;
        if (payload) {
            Object.keys(payload).forEach((key) => {
                url += `&${key}=${payload[key]}`;
            });
        }
        await apiClient
            .get(
                url, {
                    responseType: "blob",
                }
            )
            .then(() => {
                window.location = url;
            });
    },

    async dotsgetExport(context, payload) {
       
        let url = `https://api.mdr.tbtheunion.com/api/dots/patient/export?`;
        if (payload) {
            Object.keys(payload).forEach((key) => {
                url += `&${key}=${payload[key]}`;
            });
        }
        await apiClient
            .get(
                url, {
                    responseType: "blob",
                }
            )
            .then(() => {
                window.location = url;
            });
    },

    async familymembergetExport(context, payload) {
        let url = `https://api.mdr.tbtheunion.com/api/familymember/export?`;
        if (payload) {
            Object.keys(payload).forEach((key) => {
                url += `&${key}=${payload[key]}`;
            });
        }
        await apiClient
            .get(
                url, {
                    responseType: "blob",
                }
            )
            .then(() => {
                window.location = url;
            });
    },

    async issueExport(context, payload) {

        let url = `https://api.mdr.tbtheunion.com/api/outcome-issue/export?`;
        if (payload) {
            Object.keys(payload).forEach((key) => {
                url += `&${key}=${payload[key]}`;
            });
        }
        await apiClient
            .get(
                url, {
                    responseType: "blob",
                }
            )
            .then(() => {
                window.location = url;
            });
    },

    async finishedExport(context, payload) {

        let url = `https://api.mdr.tbtheunion.com/api/outcome/export?`;
        if (payload) {
            Object.keys(payload).forEach((key) => {
                url += `&${key}=${payload[key]}`;
            });
        }
        await apiClient
            .get(
                url, {
                    responseType: "blob",
                }
            )
            .then(() => {
                window.location = url;
            });
    },

    // async addCi(context, payload) {
    //     const response = await Request.post_data(addCiUrl, payload);
    //     const responseChecker = new ResponseChecker(response);
    //     responseChecker.checkResponse();
    //     if (responseChecker.isResponseStatusSuccess()) {
    //         notiMessage.displayNotiMsg("Saved Success");
    //         return true;
    //     }
    //     return false;
    // },

    // async getCiEach({ commit }, id) {
    //     const response = await Request.get_data(eachCiUrl, {
    //         column: "id",
    //         value: id,
    //     });
    //     const responseChecker = new ResponseChecker(response);
    //     responseChecker.checkResponse();
    //     if (responseChecker.isResponseStatusSuccess())
    //         commit("SET_CI_DATA_EACH", response);
    // },
    
    //   async deletePatient({ commit, dispatch }, payload) {
    //     const response = await Patient.deletePatient(payload).then((response) => {
    //       console.log(response);
    //       if (response.data.success) {
    //         const notification = {
    //           type: "success",
    //           status: true,
    //           message: "delete patient successfully!",
    //         };
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};